import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UnlockedIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Unlocked",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M24.6 13.75H11.26l-.84-2.71a4.78 4.78 0 1 1 9.12-2.85v.04l.29.9 2.7-.85-.28-.9c-1-3.14-3.89-5.37-7.31-5.37-.77 0-1.54.12-2.25.34-3.12 1.01-5.35 3.88-5.35 7.29 0 .8.13 1.58.36 2.3l.58 1.81h-.87a3.35 3.35 0 0 0-3.35 3.35v9.55c0 1.85 1.5 3.35 3.35 3.35h17.2c1.85 0 3.35-1.5 3.35-3.35V17.1c0-1.85-1.5-3.35-3.35-3.35Zm-7.64 8.61v2.85c0 .52-.43.95-.95.95s-.95-.43-.95-.95v-2.85c-1.05 0-1.91-.86-1.91-1.91s.86-1.92 1.91-1.92h1.91c1.05 0 1.92.86 1.92 1.92s-.86 1.91-1.92 1.91Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "m17.51 25-1.22-4.57L15.06 25z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M17.51 26.14h-2.45c-.36 0-.69-.17-.91-.45s-.29-.65-.2-.99l1.23-4.57c.13-.5.59-.85 1.1-.85.52 0 .97.35 1.1.85l1.22 4.57c.09.34.02.71-.2.99s-.55.45-.91.45Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M24.29 31.86h-16c-1.89 0-3.43-1.54-3.43-3.43v-16C4.86 10.54 6.4 9 8.29 9h16c1.89 0 3.43 1.54 3.43 3.43v16c0 1.89-1.54 3.43-3.43 3.43m-16-20.57c-.63 0-1.14.51-1.14 1.14v16c0 .63.51 1.14 1.14 1.14h16c.63 0 1.14-.51 1.14-1.14v-16c0-.63-.51-1.14-1.14-1.14z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11.71 11.28c-.63 0-1.14-.51-1.14-1.14V5.57c0-3.15 2.57-5.71 5.72-5.71a5.72 5.72 0 0 1 4.95 2.86c.32.55.13 1.25-.42 1.56-.55.32-1.25.13-1.56-.42a3.4 3.4 0 0 0-.71-.86 3.427 3.427 0 0 0-5.7 2.57v4.57c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "16.29",
        cy: "17.57",
        r: "1.71"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16.29 20.43a2.86 2.86 0 1 1-.001-5.719 2.86 2.86 0 0 1 .001 5.719m0-3.43c-.31 0-.57.26-.57.57s.26.57.57.57.57-.26.57-.57-.26-.57-.57-.57"
      })]
    })
  }));
};
UnlockedIcon.displayName = 'UnlockedIcon';